module.exports = __webpack_public_path__ + "static/media/Sponsors-banner.904b8cee.png";